module.exports = __webpack_public_path__ + "assets/images/search.fd771188.svg";